// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__4kGiH","logo":"Navbar_logo__Wez4g","menu":"Navbar_menu__CXeMk","menuItem":"Navbar_menuItem__5gYuW","loginButton":"Navbar_loginButton__M8XV6"};